import {AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {MatCheckboxChange, MatPaginator, MatSelectChange, MatSort} from '@angular/material';
import {Subject} from 'rxjs';
import {tap} from 'rxjs/internal/operators';
import * as moment from 'moment';
import swal from 'sweetalert2';

import {fuseAnimations} from '@fuse/animations';

import {BaseService} from '../../../services/base.service';
import {AuthService} from '../../../services/auth.service';
import {BaseDatasourceService} from '../../../services/base-datasource.service';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../../../config/date_format';
import {Endpoints} from '../../../config/endpoints';
import {getEnumSelector} from '../../../services/utilities';
import {ExpenseClaim} from '../../../models/expense-claim';
import {ForwardStatusEnum} from '../../../enums/forward-status-enum';
import {User} from '../../../models/user';
import {MarketLevel} from '../../../models/market-level';
import {Market} from '../../../models/market';
import {SelectionModel} from '@angular/cdk/collections';
import {ExpenseType} from '../../../models/expense-type';
import {BillingOrganization} from '../../../models/BillingOrganization';
import {ActivatedRoute, Router} from '@angular/router';
import {AttendanceListComponent} from '../../attendance/attendance-list/attendance-list.component';
import {SyncStatusEnum} from '../../../enums/sync-status-enum';
import {Title} from '@angular/platform-browser';
import { TitleBroadcastService } from 'app/services/title-broadcast.service';

@Component({
    selector: 'expense-claim-list',
    templateUrl: './expense-claim-list.component.html',
    styleUrls: ['./expense-claim-list.component.scss'],
    animations: fuseAnimations
})
export class ExpenseClaimListComponent implements OnInit, OnDestroy, AfterViewInit {
    private filetype: string;


    constructor(private service: BaseService, private router: Router, private auth: AuthService,
                private attendence: AttendanceListComponent, private route: ActivatedRoute, private title: Title,private titleBroadcastService: TitleBroadcastService ) {
        this._unsubscribeAll = new Subject();
        this.titleBroadcastService.title.next('Expense Claim List');           
        this.loggedUser = this.auth.user;
        this.marketLevels = this.loggedUser.MarketLevelHierarchy;
        this.marketLevels.forEach(pMarketLevel => {
            this.markets[pMarketLevel.Rank] = [];
            this.selectedMarket[pMarketLevel.Rank] = null;
        });
        this.canAddExpenseClaim = this.auth.hasAccess('EXPENSE_CLAIM', 'ADD_EXPENSE_CLAIM');
        this.canEditExpenseClaim = this.auth.hasAccess('EXPENSE_CLAIM', 'EDIT_EXPENSE_CLAIM');
        this.canForwardExpenseClaim = this.auth.hasAccess('EXPENSE_CLAIM', 'FORWARD_EXPENSE_CLAIM');
        this.canApproveExpenseClaim = this.auth.hasAccess('EXPENSE_CLAIM', 'APPROVE_EXPENSE_CLAIM');
    }

    map = new Map([['a', 'csv'], ['b', 'xslx']]);
    loggedUser: User;
    canAddExpenseClaim = false;
    canEditExpenseClaim = false;
    canForwardExpenseClaim = false;
    canApproveExpenseClaim = false;
    addBillingOrganization = false;
    allApproved = false;


    dataSource: BaseDatasourceService<ExpenseClaim>;
    displayedColumns: string[] = ['checkbox', 'Id', 'ExpenseDate', 'User', 'Designation', 'Market', 'Voucher', 'TotalAmount', 'Status', 'Approvers', 'star'];
    previewColumns: string[] = ['checkbox', 'ExpenseType', 'Date', 'From', 'To', 'ExpenseSubType', 'Market', 'Amount', 'Remarks', 'Status', 'Approvers', 'star'];
    selection = new SelectionModel<ExpenseClaim>(true, []);
    filters = {
        FileType: null,
        MarketIdList: null,
        Only: false,
        Voucher: null,
        ApproveFilter: null,
        SyncStatus: null,
        Id: null,
        FromDate: moment().date(1).format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        ToDate: moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME),
        UserId: null,
        NotUserId: null,
        BillingOrganizationId: null,
        SearchKey: null,
        ExpenseTypeId: null,
        SortBy: 'CreatedAt',
        SortOrder: 'desc',
        Active: true,
        PageNumber: 0,
        RecordsPerPage: 20
    };

    billingOrganizationList: BillingOrganization[] = [];
    expenseTypeList: ExpenseType[] = [];

    marketLevels: MarketLevel[];
    markets = [];
    selectedMarket: Market[] = [];
    marketLevel: MarketLevel;
    market = new Market();

    search = false;
    showPreview = false;

    statusEnum = ForwardStatusEnum;
    statusList = getEnumSelector(ForwardStatusEnum);
    syncList = getEnumSelector(SyncStatusEnum);
    submitInProgress = false;
    expenseClaimList = [];
    expenseTypes: ExpenseType[] = [];

    private _unsubscribeAll: Subject<any>;

    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    private isSelected: boolean;
    private isSelected1: boolean;
    private filename: string;

    @HostListener('document:keydown', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            this.reloadDatatable(true);
        }
    }

    ngOnInit(): void {
        this.title.setTitle('Expense Claim List');
        this.service.getOrganizationSettings(this.loggedUser.Organization.Id).subscribe(pOrganizationSettings => {
            pOrganizationSettings.forEach(pModule => {
                if (pModule.ModuleName === 'EXPENSE_CLAIM') {
                    pModule.ModularSettings.forEach(pSettings => {
                        if (pSettings.SettingsName === 'ADD_BILLING_ORGANIZATION_WITH_EXPENSE_CLAIM') {
                            this.addBillingOrganization = pSettings.SettingsValue === 'true';

                            if (this.addBillingOrganization) {
                                this.service.getBillingOrganizationList({}).subscribe(pBillingOrganizations => this.billingOrganizationList = pBillingOrganizations);
                                this.displayedColumns = ['checkbox', 'Id', 'ExpenseDate', 'User', 'Designation', 'Market', 'BillingOrganization', 'Voucher', 'TotalAmount', 'Status', 'star'];
                            }
                        }
                    });
                }
            });
        });

        this.service.getMarketList({MarketLevelId: this.marketLevels[0].Id, Active: true}).subscribe(pMarkets => this.markets[1] = pMarkets);
        this.service.getExpenseTypeList({Active: true}).subscribe(pExpenseTypeList => this.expenseTypeList = pExpenseTypeList);

        this.route.queryParams.subscribe(params => {
            if (this.search == false) {
                if (params.marketIdList) {
                    const marketId = parseInt(params.marketIdList, 10);
                    this.filters.MarketIdList = [marketId];
                    this.service.getMarketDetails(this.filters.MarketIdList).subscribe(pMarket => {
                        this.market = pMarket;
                        this._setMarketLevel(this.market.MarketLevel.Id);
                    });
                } else {
                    this.filters.MarketIdList = null;
                    this.marketLevels = this.loggedUser.MarketLevelHierarchy;
                    this.marketLevels.forEach(pMarketLevel => {
                        this.markets[pMarketLevel.Rank] = [];
                        this.selectedMarket[pMarketLevel.Rank] = null;
                    });
                    this.service.getMarketList({MarketLevelId: this.marketLevels[0].Id, Active: true}).subscribe(
                        pMarkets => this.markets[1] = pMarkets);
                }

                if (params.voucher) {
                    this.filters.Voucher = params.voucher;
                } else {
                    this.filters.Voucher = null;
                }
                if (params.approveFilter) {
                    this.filters.ApproveFilter = params.approveFilter;
                } else {
                    this.filters.ApproveFilter = null;
                }

                if (params.syncStatus) {
                    this.filters.SyncStatus = params.syncStatus;
                } else {
                    this.filters.SyncStatus = null;
                }
                if (params.id) {
                    this.filters.Id = params.id;
                } else {
                    this.filters.Id = null;
                }
                if (params.fromDate) {
                    this.filters.FromDate = params.fromDate;
                } else {
                    this.filters.FromDate = moment().date(1).format(SERVER_DATE_FORMAT_WITHOUT_TIME);
                }
                if (params.toDate) {
                    this.filters.ToDate = params.toDate;
                } else {
                    this.filters.ToDate = moment().format(SERVER_DATE_FORMAT_WITHOUT_TIME);
                }
                if (params.billingOrganizationId) {
                    this.filters.BillingOrganizationId = params.billingOrganizationId;
                } else {
                    this.filters.BillingOrganizationId = null;
                }
                if (params.searchKey) {
                    this.filters.SearchKey = params.searchKey;
                } else {
                    this.filters.SearchKey = null;
                }
                if (params.expenseTypeId) {
                    this.filters.ExpenseTypeId = params.expenseTypeId;
                } else {
                    this.filters.ExpenseTypeId = null;
                }
                this.dataSource = new BaseDatasourceService<ExpenseClaim>(this.service);
                this.reloadDatatable();
            }
            this.search = false;
        });

        this.dataSource = new BaseDatasourceService<ExpenseClaim>(this.service);
        this.reloadDatatable();
    }


    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }

    ngAfterViewInit(): void {
        this.sort.sortChange.subscribe(() => this.paginator.pageIndex = this.filters.PageNumber);
        this.paginator.page.pipe(tap(() => this.saveNavigation())).subscribe();
        this.paginator.page.pipe(tap(() => this.reloadDatatable())).subscribe();
        this.sort.sortChange.pipe(tap(() => this.reloadDatatable())).subscribe();
    }


    setFromDate(pEvent): void {
        this.filters.FromDate = pEvent.value ? moment(pEvent.value).format(SERVER_DATE_FORMAT_WITHOUT_TIME) : null;
    }

    setToDate(pEvent): void {
        this.filters.ToDate = pEvent.value ? moment(pEvent.value).format(SERVER_DATE_FORMAT_WITHOUT_TIME) : null;
    }


    _resetChildrenDropdown(pParentRank: number): void {
        this.marketLevels.forEach(pMarketLevel => {
            if (pMarketLevel.Rank > pParentRank) {
                this.selectedMarket[pMarketLevel.Rank] = null;
                this.markets[pMarketLevel.Rank] = [];
            }
        });
    }

    populateChildrenMarkets(pEvent: MatSelectChange): void {
        const market: Market = pEvent.value;
        if (market) {
            this._resetChildrenDropdown(market.MarketRank);
            if (this.marketLevels[market.MarketRank]) {
                this.service.getMarketList({MarketLevelId: this.marketLevels[market.MarketRank].Id, ParentMarketId: market.Id, Active: true})
                    .subscribe(pMarkets => this.markets[market.MarketRank + 1] = pMarkets);
            }
        } else {
            this._resetChildrenDropdown(parseInt(pEvent.source.id.slice(6), 10));
        }
    }

    isAllSelected(): boolean {
        const numSelected = this.selection.selected.length;
        const numRows = this.dataSource.data.length;
        return numSelected === numRows;
    }

    /** Selects all rows if they are not all selected; otherwise clear selection. */
    masterToggle(pEvent?: MatCheckboxChange): void {

        if (!pEvent.checked) {
            this.selection.clear();
        } else {
            if (this.isAllSelected()) {
                this.selection.clear();
            } else {
                this.dataSource.data.forEach(row => {
                    if (row.CanApprove == true) {
                        this.selection.select(row);
                    }
                });
            }
        }

    }

    pageChanged(pEvent): void {
        this.filters.PageNumber = pEvent.pageIndex;
    }

    compareById(pObj1, pObj2): boolean {
        return pObj1 && pObj2 && pObj1['Id'] === pObj2['Id'];
    }

    compareMarkets(pMarket1: Market, pMarket2: Market): boolean {
        return pMarket1 && pMarket2 && pMarket1.Id === pMarket2.Id;
    }

    _setMarketLevel(id: number): void {
        this.loggedUser.MarketLevelHierarchy.forEach((marketLevel) => {
            if (marketLevel.Id == id) {
                this.marketLevel = marketLevel;
            }
        });
        this.market.MarketLevel = this.marketLevel;
        this._populateParentMarketLevelList();
    }

    _populateParentMarketLevelList(): void {
        if (this.marketLevels.length > 0) {
            this._populateFirstParent();
        }
    }

    _populateChildMarkets(market: Market): void {
        this.service.getMarketList({MarketLevelId: this.marketLevels[market.MarketRank].Id, ParentMarketId: market.Id, Active: true}).subscribe(pMarkets => {
            this.markets[this.marketLevels[market.MarketRank].Rank] = pMarkets;
            if (this.market.ParentMarketList) {
                this.market.ParentMarketList.forEach(parentMarket => {
                    if (parentMarket.MarketRank === this.marketLevels[market.MarketRank].Rank) {
                        this.selectedMarket[parentMarket.MarketRank] = parentMarket;
                        if (this.marketLevels[parentMarket.MarketRank]) {
                            this._populateChildMarkets(parentMarket);
                        }
                    }
                });
            }
        });
    }

    _populateFirstParent(): void {
        this.markets = [];
        this.selectedMarket = [];
        for (let i = 0; i < this.market.MarketLevel.Rank; i++) {
            this.service.getMarketList({MarketLevelId: this.marketLevels[i].Id, Active: true}).subscribe(pMarkets => {
                this.markets[i + 1] = pMarkets;
                // console.log(this.markets);
                if (this.market.ParentMarketList) {
                    // console.log(this.market.ParentMarketList);
                    if (i < this.market.MarketLevel.Rank - 1) {
                        this.market.ParentMarketList.forEach(parentMarket => {
                            this.selectedMarket[i + 1] = parentMarket;
                            // console.log(this.selectedMarket);
                            this._populateChildMarkets(parentMarket);

                        });
                    }
                    if (i == this.market.MarketLevel.Rank - 1) {
                        // console.log(this.market);
                        this.selectedMarket[i + 1] = this.market;
                        // console.log(this.selectedMarket);
                        this._populateChildMarkets(this.market);
                    }

                } else {
                    this.selectedMarket[i + 1] = this.market;
                    this._populateChildMarkets(this.market);
                }
            });
        }

    }

    getPreview(): void {
        this.selection.clear();
        this.showPreview = true;
        this.submitInProgress = true;
        const tempExpenseList = [];
        const seen = new Set();
        this.filters.MarketIdList = null;
        for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
            if (this.selectedMarket[i]) {
                this.filters.MarketIdList = [this.selectedMarket[i].Id];
                break;
            }
        }
        this.search = true;
        this.saveNavigation();
        this.dataSource.fetchRemoteData(Endpoints.expense_claim_list, this.filters);
        this.service.postData(Endpoints.expense_claim_list, this.filters).subscribe(pResponse => {
            this.expenseClaimList = pResponse['Data']['content'];

            this.expenseClaimList.forEach(pExpenseClaim => {
                pExpenseClaim.DetailList.forEach(pExpense => {
                    tempExpenseList.push(pExpense.ExpenseType);
                });
            });
            this.expenseTypes = tempExpenseList.filter(filters => {
                const duplicate = seen.has(filters.Id);
                seen.add(filters.Id);
                return !duplicate;
            });
            this.submitInProgress = false;
        });
    }

    checkForDuplicate(detailList, expenseName): boolean {
        let flag = true;
        for (let i = 0; i < detailList.length; i++) {
            if (detailList[i].ExpenseType.Name == expenseName.Name) {
                flag = false;
                break;
            }
        }
        return flag;
    }

    checkForAllApproved(): boolean {
        let flag = false;
        let counter = 0;
        for (let i = 0; i < this.dataSource.data.length; i++) {
            if (this.dataSource.data[i].CanApprove == false) {
                counter++;
            }
        }
        if (counter == this.dataSource.data.length) {
            flag = true;
        }
        return flag;
    }

    saveNavigation(): void {
        this.router.navigate(['expense-claim/list'], {
            queryParams: {
                marketIdList: this.filters.MarketIdList,
                voucher: this.filters.Voucher,
                approveFilter: this.filters.ApproveFilter,
                syncStatus: this.filters.SyncStatus,
                id: this.filters.Id,
                fromDate: this.filters.FromDate,
                toDate: this.filters.ToDate,
                billingOrganizationId: this.filters.BillingOrganizationId,
                searchKey: this.filters.SearchKey,
                expenseTypeId: this.filters.ExpenseTypeId,
                sortBy: this.filters.SortBy,
                sortOrder: this.filters.SortOrder,
                pageNumber: this.filters.PageNumber,
                record: this.filters.RecordsPerPage
            }
        });
    }

    reloadDatatable(pSearch?: boolean): void {
        this.selection.clear();
        if (this.sort) {
            this.filters.SortBy = this.sort.active || 'Id';
            this.filters.SortOrder = this.sort.direction || 'asc';
        }
        this.filters.PageNumber = pSearch === true ? 0 : this.paginator.pageIndex || 0;
        this.filters.RecordsPerPage = this.paginator.pageSize || 20;
        if (pSearch === true) {
            this.search = true;
            this.showPreview = false;
            this.filters.MarketIdList = null;
            for (let i = this.selectedMarket.length - 1; i >= 0; i--) {
                if (this.selectedMarket[i]) {
                    this.filters.MarketIdList = [this.selectedMarket[i].Id];
                    break;
                }
            }
            this.paginator.firstPage();
            this.saveNavigation();
        }

        this.dataSource.fetchRemoteData(Endpoints.expense_claim_list, this.filters);
    }

    bulkUpdateStatus(pStatus: ForwardStatusEnum): void {
        if (this.route.snapshot.queryParams['sortBy']) {
            this.saveNavigation();
        }
        let isForward = null;
        let isApproved = null;
        if (pStatus === this.statusEnum.FORWARDED) {
            isForward = true;
        } else if (pStatus === this.statusEnum.APPROVED) {
            isApproved = true;
        } else if (pStatus === this.statusEnum.REJECTED) {
            isForward = false;
            isApproved = false;
        }

        const idList = [];
        this.selection.selected.forEach(item => {
            idList.push(item.Id);
        });

        this.service.postData(Endpoints.expense_claim_bulk_approve, {IsApproved: isApproved, Forwarded: isForward, IdList: idList}, true)
            .subscribe(response => {
                swal(pStatus + '!', 'Claims have been ' + pStatus.toLowerCase() + '.', 'success');
                this.reloadDatatable();
            });
    }

    resetStatus(pExpenseClaim: ExpenseClaim): void {
        if (this.route.snapshot.queryParams['sortBy']) {
            this.saveNavigation();
        }
        this.service.getData(`${Endpoints.expense_claim_reset_approval}/${pExpenseClaim.Id}`)
            .subscribe(response => {
                swal('Reset!', 'Claim status changed to pending.', 'success');
                this.reloadDatatable();
            });
    }

    downloadReport(): void {
        if (this.route.snapshot.queryParams['sortBy']) {
            this.saveNavigation();
        }
        swal({
            title: 'Download Report',
            html:
                '<div class="example-container"><form> <mat-form-field><input matInput id="report" placeholder="Enter report name"' +
                '></mat-form-field><br><br>' +
                '<div class="container">\n' +
                '    <div class="col-md-12">' +
                '<input class="col-xs-3" type="radio" value="CSV" id="input1" name="filetype" checked> CSV ' +
                '<input class="col-xs-4 col-xs-offset-4" type="radio" value="XLXX" id="input2" name="filetype" style="margin-left: 20px;"> XLSX ' +
                '\n' +
                '</div>\n' +
                '</div></form><div>',
            focusConfirm: false,
            showCancelButton: true,
            confirmButtonText: 'Download',
            showLoaderOnConfirm: true,
            preConfirm: () => {
                // disableConfirmButton();
                this.isSelected = (<HTMLInputElement>document.getElementById('input1')).checked;
                this.isSelected1 = (<HTMLInputElement>document.getElementById('input2')).checked;
                this.filename = (<HTMLInputElement>document.getElementById('report')).value;
                if (this.isSelected) {
                    this.filetype = (<HTMLInputElement>document.getElementById('input1')).value;
                } else if (this.isSelected1) {
                    this.filetype = (<HTMLInputElement>document.getElementById('input2')).value;
                }
                console.log(this.filetype);
                this.filters.FileType = this.filetype;
                window.location.href = this.service.generateGetUrl(Endpoints.export_expense_claim_list, this.filters, this.filename, true);

            },
            // tslint:disable-next-line:typedef
            allowOutsideClick: () => !swal.isLoading()
        });
    }

}
